// notas
// falta crear notas del cliente y empresa al crear la cotizacion

import { useCallback, useEffect, useState } from "react";
import { etiquetas, logos } from "../../../hook/Arreglos";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { jsPDF } from "jspdf";
import "./style.css";
import Swal from "sweetalert2"; // Importar SweetAlert2
import { cambioEstadoCotizacion, eliminarCotizacion, getCotizacion, traerSalones } from "../../../store/cotizaciones/thunkCotizaciones";
import Select from "react-select";
import PDFDownload from "./PDFGenerator";

// Función para formatear la fecha a la hora local de Costa Rica
const formatearFecha = (fecha) =>
    fecha
        ? new Date(fecha).toLocaleString("es-ES", {
              timeZone: "America/Costa_Rica", // Zona horaria de Costa Rica
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
              year: "numeric",
              month: "long",
              day: "numeric",
              weekday: "long",
          })
        : "N/D";
// Definición de un arreglo que contiene los diferentes estados de una cotización de evento.
// Cada estado tiene un identificador único, un nombre descriptivo, un color asociado y un estado de actividad.
const estadosEvento = [
    { 
        id_estado: 1, 
        nombre_estado: "Cotizacion Confirmada", 
        color_estado: "#A1E450", // Color verde: indica que la cotización ha sido confirmada.
        status_estado: 1 // Estado activo.
    },
    { 
        id_estado: 2, 
        nombre_estado: "Cotizacion Tentativa", 
        color_estado: "#C5BED1", // Color gris: indica que la cotización es tentativa y aún no está confirmada.
        status_estado: 1 // Estado activo.
    },
    { 
        id_estado: 3, 
        nombre_estado: "Cotizacion Perdida", 
        color_estado: "#c4144c", // Color rojo: indica que la cotización se ha perdido o no se concretó.
        status_estado: 1 // Estado activo.
    },
    { 
        id_estado: 4, 
        nombre_estado: "Cotizacion Enviada", 
        color_estado: "#000", // Color negro: indica que la cotización ha sido enviada al cliente.
        status_estado: 1 // Estado activo.
    }
];

export const VerCotizacion = () => {
    // Hook to navigate between application routes
    const navigate = useNavigate();

    // Hook to interact with the global state (Redux)
    const dispatch = useDispatch();

    // Local state to store form data, with fields relevant to the quotation
    const [formulario, setFormulario] = useState({
        fechaCreacion: "", // Date when the form was created
        nombreCliente: "", // Name of the client
        correoCliente: "", // Email of the client
        telefonoCliente: "", // Phone number of the client
        nombreEjecutivo: "", // Name of the executive
        cargoEjecutivo: "", // Position of the executive
        correoEjecutivo: "", // Email of the executive
        telefonoEjecutivo: "", // Phone number of the executive

        consecutivo: "", // Consecutive number of the form
        nombreEvento: "", // Name of the event
        MonedaTipo: [
            // Available currency types
            { id: 1, nombre: "$", estado: false }, // Currency type 1: Dollars
            { id: 2, nombre: "¢", estado: false }, // Currency type 2: Cents
        ],
        hotelSeleccionado: "", // ID of the selected hotel
        empresaSeleccionada: "", // ID of the selected company
        fechaSeleccionadas: "Sin definir", // Selected dates for the event (default: "Undefined")
        requerimientos: [], // List of specific requirements
        otroServicios: [], // List of other contracted services
        requerimientoshabitaciones: [], // Room requirements
        totalRequerimientos: [], // Total of the requirements
        totalGlobalCotizacion: 0, // Global total of the quotation
        notaCoti: "", // Additional notes for the quotation
        tokenEvento: "", // Unique token for the event
        estadoCotizacion: "", // Status of the quotation
    });

    // Estado local para controlar si se está descargando el PDF
    const [isDownloading, setIsDownloading] = useState(false);

    // Función para asignar el logo correspondiente a un hotel
    const asignarLogo = (idHotel) => {
        // Buscar el hotel correspondiente en la lista de logos
        const hotel = logos.find((item) => item.id === Number(idHotel));
        // Devolver el logo encontrado o uno predeterminado
        return hotel ? hotel.logo : "/assets/logo2.jpg";
    };

    // Función para obtener un parámetro "data" desde la URL
    const getIdFromUrl = useCallback(() => {
        // Crear una instancia de URLSearchParams con la URL actual
        const params = new URLSearchParams(location.search);
        // Devolver el valor del parámetro "data"
        return params.get("data");
    }, [location.search]);

    // Función para obtener los salones disponibles desde la API, dado un hotel y una lista de salones
    const fetchSalonesAPI = useCallback(
        async (hotelValue, idSalones) => {
            try {
                const salones = await dispatch(traerSalones({ idHotel: hotelValue }));

                // Filtrar los salones con los ids proporcionados
                const salonesFiltrados = salones.filter((salon) => idSalones.includes(salon.id_salon));

                // Extraer los nombres de los salones filtrados
                const nombresSalones = salonesFiltrados.map((salon) => salon.nombre_salon);

                // Unir los nombres de los salones en un string
                const nombresConcatenados = nombresSalones.join(", ");

                return nombresConcatenados;
            } catch (error) {
                console.error("Error en fetchSalonesAPI:", error);
                return "Sin definir"; // Retornar "Sin definir" si hay error
            }
        },
        [dispatch],
    );

    // Asegúrate de que esta función esté definida antes de procesar los requerimientos
    const obtenerSalon = async (req) => {
        // Si no hay salones, retornar "Sin definir"
        if (req.salones_req.length === 0) return "Sin definir";

        const hotelId = req.hotelid || "200"; // Si no hay hotel, usamos "200" por defecto

        return await fetchSalonesAPI(hotelId, req.salones_req); // Obtener el salón de la API
    };

    // Function to process requirements, returning an array of promises
    const procesarRequerimientos = async (requerimiento) => {
        // Use Promise.all to handle multiple asynchronous operations concurrently
        return await Promise.all(
            // Map through each requirement in the input array
            requerimiento.map(async (req) => {
                // Fetch salon details asynchronously based on the requirement
                const salon = await obtenerSalon(req);

                // Return an object containing processed requirement data
                return {
                    id: req.id_req, // Unique ID of the requirement
                    hotel: req.hotelid || "", // ID of the associated hotel (default to empty string if not provided)
                    hora: req.hora_req, // Time of the requirement
                    fecha: [req.fecha_req], // Date(s) of the requirement (wrapped in an array)
                    cantidad: parseInt(req.pax_req), // Number of attendees (parsed as an integer)
                    articulos: req.articulo_req, // Items or services requested
                    descripcionArticulo: req.dec_req.trim(), // Description of the items (trimmed to remove extra spaces)
                    dias: parseInt(req.dias_req), // Number of days (parsed as an integer)
                    salon: salon || "Sin definir", // Salon details (default to "Undefined" if not found)
                    precio: req.precio_req, // Price of the requirement
                    subtotal: req.subtotal_req, // Subtotal for the requirement
                    articulosOptions: [], // Placeholder for item options (empty for now)
                    salonOptions: [], // Placeholder for salon options (empty for now)
                };
            }),
        );
    };

    // Función para extraer los datos de la cotización desde la API
    const extarerDatosCotizacion = useCallback(async () => {
        try {
            // Mostrar el alerta de "Cargando..."
            Swal.fire({
                title: "Cargando...",
                text: "Espera mientras cargamos los datos",
                allowOutsideClick: false, // Evitar que el usuario cierre el alert
                didOpen: () => {
                    Swal.showLoading(); // Mostrar el spinner de carga
                },
            });
            // Obtener el ID desde la URL
            const ids = getIdFromUrl();

            // Hacer la solicitud para obtener los datos de la cotización desde la API
            const resul = await dispatch(getCotizacion(ids));

            // Extraer la primera cotización de la respuesta
            const resultado = resul.cotizacion.data[0];

            // Extraer los datos de los requerimientos, otros servicios, habitaciones y el total de requerimientos
            const requerimiento = resul.requerimientos.data || [];
            const otrosServ = resul.otrosServicios.data || [];
            const habit = resul.habitaciones.data || [];
            const total_requerimientos = resul.totalRequerimientos.data["0"] || [];

            // Verificar si la cotización existe
            if (!resultado) {
                console.error("No se encontró la cotización.");
                return;
            }

            // Procesar los requerimientos y otros servicios si existen
            const requerimientosResult = requerimiento.length > 0 ? await procesarRequerimientos(requerimiento) : [];
            const OtroServiciosResult = otrosServ.length > 0 ? await procesarRequerimientos(otrosServ) : [];

            // Seleccionar la moneda activa (¢ o $) basado en el valor de la cotización
            const monedaSeleccionada = resultado.moneda_coti === 0 ? { id: 1, nombre: "$", estado: true } : { id: 2, nombre: "¢", estado: true };

            const limpiarSubtotal = (valor) => parseFloat((valor || "").toString().replace(/[^0-9.]/g, "")) || 0;

            const formatter = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            const totalMonto =
                limpiarSubtotal(total_requerimientos.totalReq_Subt) +
                limpiarSubtotal(total_requerimientos.totalOtro_Subt) +
                limpiarSubtotal(total_requerimientos.totalsubtRoom_Subt);

            // Actualizar el estado del formulario con los datos obtenidos de la cotización
            setFormulario((prev) => ({
                ...prev,
                consecutivo: resultado.id_consecutivo_coti, // Consecutivo de la cotización
                estadoCotizacion: resultado.Estado_coti, // Consecutivo de la cotización
                hotelSeleccionado: resultado.id_hotel_coti, // ID del hotel seleccionado
                fechaCreacion: formatearFecha(resultado.fecha_creacion_coti), // Fecha de creación de la cotización
                fechaSeleccionadas: resultado.fecha_evento_coti || "Sin definir", // Fecha del evento o valor por defecto
                nombreEvento: resultado.nombre_evento_coti, // Nombre del evento
                nombreCliente: resultado.nombre_cliente || "Sin definir", // Nombre del cliente o valor por defecto
                correoCliente: resultado.correo_cleinte || "Sin definir", // Correo del cliente o valor por defecto
                telefonoCliente: resultado.telefono_cliente || "Sin definir", // Teléfono del cliente o valor por defecto
                nombreEjecutivo: resultado.name_admin || "Sin definir", // Nombre del ejecutivo o valor por defecto
                cargoEjecutivo: resultado.puesto || "Sin definir", // Cargo del ejecutivo o valor por defecto
                correoEjecutivo: resultado.email_admin || "Sin definir", // Correo del ejecutivo o valor por defecto
                telefonoEjecutivo: resultado.phone_admin || "Sin definir", // Teléfono del ejecutivo o valor por defecto
                requerimientos: requerimientosResult, // Lista de requerimientos procesados
                otroServicios: OtroServiciosResult, // Lista de otros servicios procesados
                empresaSeleccionada: resultado.nombre_empresa, // Nombre de la empresa seleccionada
                totalRequerimientos: total_requerimientos, // Total de los requerimientos
                requerimientoshabitaciones: habit, // Habitaciones solicitadas
                MonedaTipo: prev.MonedaTipo.map((moneda) =>
                    moneda.id === monedaSeleccionada.id ? { ...moneda, estado: true } : { ...moneda, estado: false },
                ), // Actualizar el estado de la moneda seleccionada
                notaCoti: resultado.nota_coti || "", // Nota de la cotización o valor por defecto
                tokenEvento: resultado.ReferenciaEvento, // Token único del evento
                totalGlobalCotizacion: formatter.format(totalMonto),
            }));
            Swal.close();
        } catch (error) {
            // Manejo de errores en caso de fallos en la solicitud de la cotización
            console.error("Error al obtener los datos de cotización:", error);
            Swal.close();
        }
    }, [dispatch]); // Dependencia de la función useCallback

    // Hook para ejecutar una acción al montar el componente
    useEffect(() => {
        extarerDatosCotizacion(); // Extraer datos de la cotización
    }, []);


    const EliminarCotizacion = () => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "Una vez confirmada, esta acción no se puede revertir.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Mostrar el preload mientras se realiza la acción
                Swal.fire({
                    title: "Eliminando...",
                    text: "Por favor espera mientras eliminamos la cotización.",
                    icon: "info",
                    didOpen: () => {
                        Swal.showLoading(); // Muestra el preload
                    },
                });

                const ids = getIdFromUrl();

                await dispatch(eliminarCotizacion(formulario.consecutivo));
                // Aquí iría la lógica para eliminar la cotización, por ejemplo, una llamada a una API
                Swal.fire({
                    title: "¡Eliminado!",
                    text: "La cotización ha sido eliminada.",
                    icon: "success",
                }).then(() => {
                    // Redirigir a otra vista después de 4 segundos
                    setTimeout(() => {
                        // Usa la función que uses para la navegación en tu framework
                        window.location.href = "/cotizaciones/lista"; // Navegación a otra vista
                    }, 1000); // 4 segundos
                });
            }
        });
    };

    const EditarCotizacion = () => {
        const ids = getIdFromUrl();
        navigate(`/cotizaciones/editar?data=${ids}`); // Navegación a otra vista
    };

    const CopiaCotizacion = () => {
        const ids = getIdFromUrl();
        navigate(`/cotizaciones/copia?data=${ids}`); // Navegación a otra vista
    };
    // Función para asignar etiquetas a los hoteles
    const asignarEtiqueta = (idHotel) => {
        // Buscar la etiqueta correspondiente al ID del hotel
        const hotel = etiquetas.find((item) => item.id === idHotel);
        // Devolver la etiqueta encontrada o una cadena vacía
        return hotel ? hotel.logo : "";
    };

    /**
     * Obtiene el símbolo de la moneda activa (la que tenga estado: true).
     * Por defecto es "$" si no se encuentra otra activada.
     */
    const monedaActiva = formulario.MonedaTipo.find((moneda) => moneda.estado)?.nombre || "$";

    const [selectedOption, setSelectedOption] = useState(null);

    // Transformar los datos de `estadosEvento` al formato requerido por `react-select`
    const optionses = estadosEvento.map((estado) => ({
        value: estado.id_estado,
        label: estado.nombre_estado,
    }));

    useEffect(() => {
        const estadoActual = estadosEvento.find((estado) => estado.nombre_estado.includes(formulario.estadoCotizacion));

        setSelectedOption(
            estadoActual
                ? {
                      value: estadoActual.id_estado,
                      label: estadoActual.nombre_estado,
                  }
                : null,
        );
    }, [formulario.estadoCotizacion]);

    const handleChange = (selected) => {
        setSelectedOption(selected);
        const estadoSeleccionado = estadosEvento.find((estado) => estado.id_estado === selected.value);
        const cotizacionId = formulario.consecutivo;

        if (!cotizacionId) {
            Swal.fire("Error", "No se pudo identificar la cotización para actualizar el estado.", "error");
            return;
        }

        if (selected?.value === 1) {
            Swal.fire({
                title: "¿Está seguro?",
                text: "Esta acción confirmará la cotización y todos los eventos relacionados. No se puede revertir.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, confirmar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setFormulario((prev) => ({
                        ...prev,
                        estadoCotizacion: "Confirmada", // Consecutivo de la cotización
                    }));
                    await dispatch(cambioEstadoCotizacion(cotizacionId, estadoSeleccionado, selected?.value, formulario.tokenEvento));
                    // Lógica para confirmar la cotización y los eventos relacionados
                    Swal.fire("Confirmado", "La cotización y los eventos relacionados han sido confirmados.", "success");
                }
            });
        }

        if (selected?.value === 2) {
            Swal.fire({
                title: "¿Está seguro?",
                text: "Esta acción marcará la cotización y todos los eventos relacionados como tentativos. No se puede revertir.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setFormulario((prev) => ({
                        ...prev,
                        estadoCotizacion: "Tentativa", // Cambiar a estado tentativo
                    }));
                    await dispatch(cambioEstadoCotizacion(cotizacionId, estadoSeleccionado, selected?.value, formulario.tokenEvento));
                    // Lógica para marcar la cotización y los eventos relacionados como tentativos
                    Swal.fire("Tentativo", "La cotización y los eventos relacionados han sido marcados como tentativos.", "success");
                }
            });
        }

        if (selected?.value === 4) {
            Swal.fire({
                title: "¿Está seguro?",
                text: "Confirmar que sea enviado al cliente.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setFormulario((prev) => ({
                        ...prev,
                        estadoCotizacion: "Enviado", // Cambiar a estado tentativo
                    }));
                    await dispatch(cambioEstadoCotizacion(cotizacionId, estadoSeleccionado, selected?.value, formulario.tokenEvento));
                    // Lógica para marcar la cotización y los eventos relacionados como tentativos
                    Swal.fire("Enviado", "La cotización se envio", "success");
                }
            });
        }

        if (selected?.value === 3) {
            Swal.fire({
                title: "¿Está seguro?",
                text: "Esta acción marcará la cotización como perdida. Esto implica inactivarla y no se puede revertir.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setFormulario((prev) => ({
                        ...prev,
                        estadoCotizacion: "Perdida", // Cambiar a estado perdida
                    }));
                    await dispatch(cambioEstadoCotizacion(cotizacionId, estadoSeleccionado, selected?.value, formulario.tokenEvento));
                    if (formulario.tokenEvento) {
                        // Segunda confirmación: Eventos relacionados
                        Swal.fire({
                            title: "¿Desea también marcar como perdidos los eventos relacionados?",
                            text: "Si confirma, los eventos relacionados serán marcados como perdidos. Esto no se puede revertir.",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Sí, Confirmar",
                            cancelButtonText: "No",
                        }).then(async (secondResult) => {
                            if (secondResult.isConfirmed) {
                                // Lógica para marcar eventos relacionados como perdidos
                                await dispatch(cambioEstadoCotizacion(cotizacionId, estadoSeleccionado, 6, formulario.tokenEvento));
                                Swal.fire("Perdido", "La cotización y los eventos relacionados han sido marcados como perdidos.", "success");
                            }
                        });
                    } else {
                        Swal.fire("Perdida", "Solo se marcó como perdida la cotización.", "info");
                    }
                }
            });
        }
    };

    function getAlertClass(estado) {
        switch (estado) {
            case "Confirmada":
                return "success";
            case "Pendiente":
                return "warning";
            case "Tentativa":
                return "primary";
            case "Perdida":
                return "danger";
            case "Enviado":
                return "dark";
            default:
                return "secondary"; // Clase por defecto, opcional
        }
    }
    return (
        <>
            <div className="alert alert-success d-block text-center text-uppercase">
                <i className="feather icon-check-circle me-2"></i>Usted esta en Ver Cotizacion
            </div>
            <div role="alert" className={`fade alert alert-${getAlertClass(formulario.estadoCotizacion)} show`}>
                Estado : {formulario.estadoCotizacion}
            </div>
            <div>
                <h4>Selecciona un Estado</h4>
                <Select
                    options={optionses}
                    value={selectedOption}
                    onChange={handleChange}
                    placeholder="Selecciona un estado"
                    isClearable
                    isSearchable={false}
                />
            </div>

            <div id="cotizacion-contenido" className={`g-3 row ${isDownloading ? "col-12" : "col-12"}`} style={{ fontSize: "13pt" }}>
                <div className="col-12">
                    <div className="row align-items-center g-3">
                        <div className="col-sm-12">
                            <div className="d-flex align-items-center mb-2">
                                <img
                                    alt="images"
                                    loading="lazy"
                                    width="160"
                                    height="28"
                                    decoding="async"
                                    className="img-fluid"
                                    src={asignarLogo(formulario.hotelSeleccionado)}
                                    style={{ verticalAlign: "middle" }} // Alineación vertical
                                />
                                <h2 className="mb-0 ms-auto" style={{ marginTop: "50px" }}>
                                    #{formulario.consecutivo}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información del Ejecutivo</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Ejecutiva: <strong>{formulario.nombreEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Cargo: <strong>{formulario.cargoEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Correo Electrónico: <strong>{formulario.correoEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div>
                            <h5 className="mb-1 text-grey small-text">
                                Teléfono: <strong>{formulario.telefonoEjecutivo}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información del Cliente</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Empresa: <strong>{formulario.empresaSeleccionada}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Cliente: <strong>{formulario.nombreCliente}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Correo Electrónico: <strong>{formulario.correoCliente}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div>
                            <h5 className="mb-1 text-grey small-text">
                                Teléfono: <strong>{formulario.telefonoCliente}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información de la Cotización</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Número Cotización: <strong>#{formulario.consecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Fecha cotización: <strong>{formulario.fechaCreacion}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Fechas Evento: <strong>{formulario.fechaSeleccionadas || "Sin definir"}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Nombre Evento: <strong>{formulario.nombreEvento}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                {formulario.requerimientos.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            REQUERIMIENTO DE EVENTO
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>Fecha</th>
                                        <th style={{ width: "1%" }}>Hora</th>
                                        <th style={{ width: "1%" }}>Cant.</th>
                                        <th style={{ width: "15%" }}>Desc. artículo</th>
                                        <th style={{ width: "1%" }}>Días</th>
                                        <th style={{ width: "5%" }}>Salones</th>
                                        <th style={{ width: "1%" }}>Precio {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>Subto. {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.requerimientos.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>
                                                {
                                                    typeof requerimiento.fecha === "string"
                                                        ? requerimiento.fecha.split(",").map((part, idx) => (
                                                              <span key={idx}>
                                                                  {part.trim()}
                                                                  <br />
                                                              </span> // Se agrega un <br /> por cada coma
                                                          ))
                                                        : requerimiento.fecha // Si no es string, se muestra tal cual
                                                }
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.hora === "NLL" ? "Sin definir" : requerimiento.hora}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cantidad}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.descripcionArticulo}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dias}</td>
                                            <td style={{ fontSize: "13px" }}>
                                                {requerimiento.salon
                                                    ? requerimiento.salon.includes(",")
                                                        ? requerimiento.salon.split(",").map((parte, index) => (
                                                              <span key={index}>
                                                                  {parte.trim()}
                                                                  <br />
                                                              </span>
                                                          ))
                                                        : requerimiento.salon
                                                    : "Sin definir"}
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.precio}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.subtotal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.requerimientos.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtReq_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.treceReq_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>10% IMP.SERV {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.diezReq_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL A&B {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalReq_Subt}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {formulario.otroServicios.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            OTROS SERVICIOS
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>Fecha</th>
                                        <th style={{ width: "1%" }}>Hora</th>
                                        <th style={{ width: "1%" }}>Cant.</th>
                                        <th style={{ width: "15%" }}>Desc. artículo</th>
                                        <th style={{ width: "1%" }}>Días</th>
                                        <th style={{ width: "5%" }}>Salones</th>
                                        <th style={{ width: "1%" }}>Precio {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>Subto. {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.otroServicios.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>
                                                {
                                                    typeof requerimiento.fecha === "string"
                                                        ? requerimiento.fecha.split(",").map((part, idx) => (
                                                              <span key={idx}>
                                                                  {part.trim()}
                                                                  <br />
                                                              </span> // Se agrega un <br /> por cada coma
                                                          ))
                                                        : requerimiento.fecha // Si no es string, se muestra tal cual
                                                }
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.hora === "NLL" ? "Sin definir" : requerimiento.hora}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cantidad}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.descripcionArticulo}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dias}</td>
                                            <td style={{ fontSize: "13px" }}>
                                                {requerimiento.salon
                                                    ? requerimiento.salon.includes(",")
                                                        ? requerimiento.salon.split(",").map((parte, index) => (
                                                              <span key={index}>
                                                                  {parte.trim()}
                                                                  <br />
                                                              </span>
                                                          ))
                                                        : requerimiento.salon
                                                    : "Sin definir"}
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.precio}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.subtotal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.otroServicios.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtOtro_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.treceOtro_Subt}</p>
                                </div>
                            </div>

                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL MONTAJE {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalOtro_Subt}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {formulario.requerimientoshabitaciones.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            REQUERIMIENTOS DE HABITACIONES
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>FECHA IN</th>
                                        <th style={{ width: "1%" }}>FECHA OUT</th>
                                        <th style={{ width: "1%" }}>NOCHES</th>
                                        <th style={{ width: "15%" }}>DEC. HABITACIÓN</th>
                                        <th style={{ width: "1%" }}>CANT. HABITACION.</th>
                                        <th style={{ width: "5%" }}>TARIFA * NOCHE {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>SUB TOTAL {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.requerimientoshabitaciones.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>{requerimiento.fechin_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.fechout_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.noches_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dec_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cant_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.tarifa_roomreq}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.sub_roomreq}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.requerimientoshabitaciones.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtsubtRoom_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.trecesubtRoom_Subt}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TIP MUCAMA {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.mucamasubtRoom_Subt}</p>
                                </div>
                            </div>

                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL HABITACIONES {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalsubtRoom_Subt}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-12">
                    <div
                        style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                        className="alert alert-secondary small-title"
                        role="alert"
                    >
                        TOTALES GENERAL
                    </div>
                    <div className="text-start">
                        <div className="invoice-total ms-auto p-3 border rounded shadow-sm">
                            <div className="row align-items-center mb-2">
                                <div className="col-6">
                                    <p className="text-muted mb-0 text-start"> TOTAL GENERAL {monedaActiva} :</p>
                                </div>
                                <div className="col-6 text-end">
                                    <input
                                        disabled
                                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.totalGlobalCotizacion}
                                    />
                                </div>
                            </div>
                        </div>
                        <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                    </div>
                </div>

                <div className="col-12">
                    <label className="form-label">Notas:</label>
                    <p className="mb-0">{formulario.notaCoti || ""}</p>
                </div>
                <center>
                    <img
                        src={asignarEtiqueta(formulario.hotelSeleccionado)}
                        className="img-thumbnail"
                        style={{
                            width: "%", // Ajusta el tamaño al 50% del contenedor
                            height: "auto",
                            opacity: 15, // Aplica transparencia (0.0 es totalmente transparente, 1.0 es opaco)
                        }}
                    />
                </center>
            </div>
            <br />
            <br />
            <div className="col-12 text-end d-print-none">
                <PDFDownload formulario={formulario} nombre="Co_" />
                <button onClick={EliminarCotizacion} type="button" className="btn btn-danger me-2">
                    <i className="ti ti-trash"></i> Eliminar Cotización
                </button>
                <button onClick={CopiaCotizacion} type="button" className="btn btn-dark me-2">
                    <i className="ti ti-box-multiple-1"></i> Generar Copia
                </button>
                <button onClick={EditarCotizacion} type="button" className="btn btn-warning">
                    <i className="ti ti-pencil"></i> Editar Cotización
                </button>
            </div>
        </>
    );
};
